import { PiCheckCircleDuotone, PiInfoDuotone, PiWarningDuotone, PiWarningOctagonDuotone } from "react-icons/pi";

// ===== DIRECCIONES DEL VIENTO =====
export const windDirectionsSpanish = [
    { label: 'Norte', value: 'N' },
    { label: 'Noroeste', value: 'NW' },
    { label: 'Oeste', value: 'W' },
    { label: 'Suroeste', value: 'SW' },
    { label: 'Sur', value: 'S' },
    { label: 'Sureste', value: 'SE' },
    { label: 'Este', value: 'E' },
    { label: 'Noreste', value: 'NE' },
]

// ===== MESES =====
export const Months = [
    { label: 'Enero', value: 1 },
    { label: 'Febrero', value: 2 },
    { label: 'Marzo', value: 3 },
    { label: 'Abril', value: 4 },
    { label: 'Mayo', value: 5 },
    { label: 'Junio', value: 6 },
    { label: 'Julio', value: 7 },
    { label: 'Agosto', value: 8 },
    { label: 'Septiembre', value: 9 },
    { label: 'Octubre', value: 10 },
    { label: 'Noviembre', value: 11 },
    { label: 'Diciembre', value: 12 },
]

// ===== ESTADOS DE VEHÍCULOS =====
export const vehicleStatusesSpanish = [
    { label: 'Disponible', value: 'available', color: '#28a745' },
    { label: 'En Taller', value: 'in_workshop', color: '#007bff' },
    { label: 'Vendido', value: 'sold', color: '#dc3545' },
]

// ===== ESTADOS DE RECOGIDA =====
export const pickupStatuses = [
    { label: 'Planificada', value: 'planned', color: '#2563eb', gradientBg: 'bg-gradient-to-r from-blue-100 to-white/25 to-80%' },              // Azul brillante
    { label: 'Iniciada por Conductor', value: 'started_by_driver', color: '#a5b4fc', gradientBg: 'bg-gradient-to-r from-indigo-100 to-white/25 to-80%' }, // Indigo suave (apagado)
    { label: 'Pendiente de Firma', value: 'signature_pending', color: '#f59e0b', gradientBg: 'bg-gradient-to-r from-amber-100 to-white/25 to-80%' }, // Ámbar intenso
    { label: 'Reprogramada', value: 'rescheduled', color: '#f97316', gradientBg: 'bg-gradient-to-r from-orange-100 to-white/25 to-80%' },          // Naranja intenso
    { label: 'Finalizada por Conductor', value: 'finished_by_driver', color: '#86efac', gradientBg: 'bg-gradient-to-r from-lime-100 to-white/25 to-80%' }, // Verde apagado (menos relevante)
    { label: 'Completada', value: 'completed', color: '#10b981', gradientBg: 'bg-gradient-to-r from-green-100 to-white/25 to-80%' },              // Verde llamativo
    { label: 'Validada por Administrador', value: 'validated_by_admin', color: '#0ea5e9', gradientBg: 'bg-gradient-to-r from-sky-100 to-white/25 to-80%' }, // Azul celeste intenso
    // { label: 'Cancelada', value: 'cancelled', color: '#6b7280', gradientBg: 'bg-gradient-to-r from-gray-100 to-white/25 to-80%' },                 // Gris neutro
    { label: 'Fallida', value: 'failed', color: '#ef4444', gradientBg: 'bg-gradient-to-r from-red-100 to-white/25 to-80%' },                       // Rojo intenso
    { label: 'Rechazada por Administrador', value: 'rejected_by_admin', color: '#d946ef', gradientBg: 'bg-gradient-to-r from-fuchsia-100 to-white/25 to-80%' }, // Fucsia intenso
];

// ===== TIPOS DE MENSAJE =====
export const pickupMessagesTypes = [
    { label: 'Info', value: 'info', color: 'info', icon: PiInfoDuotone },
    { label: 'Advertencia', value: 'warning', color: 'warning', icon: PiWarningDuotone },
    { label: 'Alerta', value: 'alert', color: 'danger', icon: PiWarningOctagonDuotone },
    { label: 'Éxito', value: 'success', color: 'success', icon: PiCheckCircleDuotone }
]

// ===== OPCIONES SÍ/NO =====
export const yesNoOptions = [
    { label: 'Todos', value: 'null' },
    { label: 'Sí', value: true },
    { label: 'No', value: false }
]

// ===== TIPOS DE CONCEPTO =====
export const activeInactiveOptions = [
    { label: 'Todos', value: 'null' },
    { label: 'Activo', value: true },
    { label: 'Inactivo', value: false }
]


// ===== TIPOS DE RETRIBUCIÓN =====
export const retributionTypes = [
    { label: 'Productos', value: 'product' },
    { label: 'Servicios', value: 'service' },
    { label: 'Dinero', value: 'money' },
    { label: 'Mixto', value: 'mixed' }
]

// ===== TIPOS DE MANTENIMIENTO =====
export const maintenanceTypes = [
    { label: 'Mantenimiento preventivo', value: 'preventive' },
    { label: 'Mantenimiento correctivo', value: 'corrective' },
    { label: 'Revisión técnica', value: 'check' },
    { label: 'Cambio de aceite', value: 'oil' },
    { label: 'Cambio de neumáticos', value: 'tires' },
    { label: 'Cambio de filtros', value: 'filters' },
    { label: 'Reparación', value: 'repair' },
    { label: 'Limpieza', value: 'cleaning' },
    { label: 'Otros', value: 'other' }
]

// ===== TIPOS DE DISPONIBILIDAD =====
export const availabilityTypes = [
    { label: 'Todo el día', value: 'allday' },
    { label: 'Mañanas', value: 'mornings' },
    { label: 'Tardes', value: 'Tarde' }
]

// ===== ESTADOS DE PROVEEDORES =====
export const providerStatuses = [
    { label: 'Activo', value: '1', color: '#28a745' }, // Verde
    { label: 'Cerrado', value: '2', color: '#6c757d' }, // Rojo
    { label: 'Retirado', value: '3', color: '#dc3545' }, // Gris
    { label: 'Cuarentena', value: '4', color: '#ffc107' }, // Ámbar
];
